'use strict';

customerZone.config(['$httpProvider', function($httpProvider){
    $httpProvider.interceptors.push('AuthenticationInterceptor');
}]);
